export default __webpack_public_path__ + "static/media/chevron-vertical-16.bc45ad68.svg";